<template>
  <chart-render :contentId="contentId" :dealId="dealId" @saveCallback="saveCallback"></form-render>
</template>

<script>
  import chartRender from './chartRender'
  export default {
    data() {
      return {
        contentId: 0,
        dealId: 0
        // dataId: 0,
        // ids: null
      }
    },
    created() {
      this.dealId = parseInt(this.$route.params.id)
      this.contentId = parseInt(this.$route.params.contentId)
      // this.dataId = this.$route.query.dataId ? parseInt(this.$route.query.dataId) : 0
      // this.ids = this.$route.query.ids ? this.$route.query.ids : null
    },
    methods: {
      saveCallback(isSuccess) {
        if (isSuccess) {
          setTimeout(() => {
            _g.goBack()
          }, 1500)
        }
      }
    },
    components: {
      chartRender
    }
  }
</script>


// WEBPACK FOOTER //
// chart.vue?40410654